import { Component } from "@angular/core";
import { GlobalErrorHandlerService } from "src/app/services/global-errors/global-error-handler.service";
import { isUndefined } from "src/app/services/codeUtils";

@Component({
    selector: 'app-cashier-base'
})

export class CashierBase {
    constructor(){}

    handleError(error: GlobalErrorHandlerService) {
        const customerCareGP = 'For further assistance please contact Global Payments Gaming Services customer support at 1-800-500-1973, with reference code';

        switch (error?.getErrorCode()?.toUpperCase()) {
            // Global Pay errors    
            case '02':
                error.setErrorMessage(`We’re sorry, but we are unable to proceed with your transaction. This decision was based in whole or in part on information obtained from the consumer-reporting agency <a href="https://www.vippreferred.com/fcra-decline-notice">https://www.vippreferred.com/fcra-decline-notice</a>`);
                break;
            case '10':
                error.setErrorMessage(`Unexpected Application Error. ${customerCareGP} E10`);
                break;  
            case '11':
                error.setErrorMessage(`The dollar amount of this check transaction has exceeded the available limit`);
                break; 
            case '12':
                error.setErrorMessage(`Account is not found. ${customerCareGP} E12`);
                break;  
            case '13':
                error.setErrorMessage(`ACCOUNT CLOSED. This transaction has been requested from an account that has been closed.  ${customerCareGP} T13 `);
                break; 
            case '14':
                error.setErrorMessage(`The credentials that corresponds to this account have been reported as lost or stolen. ${customerCareGP} E14 `);
                break; 
            case '15':
                error.setErrorMessage(`EDIT ERROR. One or more of the data elements provided are incorrect: The Amount of Sale was not entered. For further assistance please contact Global Payments Gaming Services customer support at 1-800-500-1973 `);
                break; 
            case '16':
                error.setErrorMessage(`PERMANENT ERROR. An invalid setting in the Merchant Account is preventing your request from being processed: Merchant ID Number Setup Error. ${customerCareGP} T16 `);
                break; 
            case '17':
                error.setErrorMessage(`INVALID BANKING. Banking information is invalid, and an  enrollment cannot be processed: Invalid Routing Number ${customerCareGP} T17 `);
                break; 
            case '18':
                error.setErrorMessage(`Fraud activity has been detected on this account. TRANSACTION DECLINED. Unable to approve your request at this time. ${customerCareGP} T18 `);
                break; 
            case '19':
                error.setErrorMessage(`SELF-EXCLUDED MATCH. We have detected a positive match with the list of Self-Excluded patrons.  No transaction can be processed at this time. ${customerCareGP} E19 `);
                break; 
            case '26':
                error.setErrorMessage(`A formatting error has been detected with the ID.  ${customerCareGP} E26 `);
                break; 
            case '50':
            case '51':
            case '52':
                error.setErrorMessage(`The processing environment is temporarily unavailable and your Enrollment cannot be processed.  You can try your request again. ${customerCareGP} E50`);
                break; 
            case '90':
                error.setErrorMessage(`Authentication error. ${customerCareGP} E90`);
                break;  
            case '91':
                error.setErrorMessage(`A formatting error has been detected ${customerCareGP} E91`);
                break; 
            case '92':
                error.setErrorMessage(`This transaction matches a previous transaction but has been declined because of the following condition: Duplicate transaction detected but timestamps differ by more than 2 minutes ${customerCareGP} 92 `);
                break; 
            case '99':  
            error.setErrorMessage(`An unexpected error has been received and your request cannot be processed.  You can try your request again. ${customerCareGP} 99 `);
                break;       
            case 'INVALID_AMOUNT_MAX':
            case 'INVALID_AMOUNT_MIN':
            case 'INVALID_TEST_CC_NUMBER':
                error.setErrorMessage((!!error.getPayload()) ? error.getPayload() : "An error has occurred. Please contact support.");
                break;
            case 'OVER_DEPOSIT_LIMIT':
                //error.setErrorMessage((!!error.getPayload()) ? error.getPayload() : "An error has occurred. Please contact support.");
                error.setErrorMessage(`You have exceeded your maximum deposit limit.`);
                break;
            case 'PROCESSOR_ERROR':
                error.setErrorMessage('Sorry, an error occured processing your deposit. Please try again');
                break;
            case 'DUPLICATE_ACH_ACCOUNT':
                error.setErrorMessage('ACH account number has already been used.');
                break;
            case 'DENIED':
                let errorPayloadDenied= error.getPayload();
                if (errorPayloadDenied && !isUndefined(errorPayloadDenied.errors) && !isUndefined(errorPayloadDenied.errors)) {
                    error.setErrorMessage(errorPayloadDenied.errors[0].message);
                } else {
                    error.setErrorMessage('We are unable to process your request. Please verify your card information and retry. If you continue to receive this message  please try another card or contact member services.');
                }
               
                break;
            case 'INVALID_PARAMETER':
                error.setErrorMessage(error.getErrorMessage());
                break;
            case 'CUSTOMER_IS_A_TEST_ACCOUNT':
                error.setErrorMessage('Failed. Customer is a test account');
                break;
            case 'TEST_ACCOUNT_MAX_FUNDS_REACHED':
                error.setErrorMessage('Failed. Customer is a test account, max funds reached');
                break;
            case 'SIGHTLINE_NOTAPPROVED':
                // error.setErrorMessage(error.getPayload().message);
                this.setSightlineErrorMessage(error, error.getPayload());
                break;
            case 'POTENTIAL_FRAUD_DETECTED':
                error.setErrorMessage('An error has occurred. Please contact support.');
                break;
            case 'UNKNOWN':
                let payload = error.getPayload();
                if (payload && payload.code != null) {
                    switch (payload.code.toUpperCase()) {
                        case 'BAD_REQUEST':
                            error.setErrorMessage(payload.message);
                            break;
                    }
                } else {
                    error.setErrorMessage( 'An error has occurred. Please contact support.');
                }
                break;
            default:
                error.setErrorMessage((!!error.getPayload()) ? error.getPayload() : "An error has occurred. Please contact support.");
                break;
        }
        return error;
    }

    setSightlineErrorMessage(error, message) {
        // @todo impoort Siteline error service
        // let sightlineErrors = new SightLineErrors(message);
        //let setErrorMessage = sightlineErrors.getError();
        //error.setErrorMessage(setErrorMessage);
    }
}